export const MODULE_NAME = 'PARTNER_KPIS_MODULE';

export function getModuleName(): string {
  return MODULE_NAME;
}
